import { render } from "./XCircleIcon.vue?vue&type=template&id=531a50f9&scoped=true"
import script from "./XCircleIcon.vue?vue&type=script&lang=js"
export * from "./XCircleIcon.vue?vue&type=script&lang=js"

import "./XCircleIcon.vue?vue&type=style&index=0&id=531a50f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531a50f9"]])

export default __exports__